import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";

import type { LiveUser } from "modules/AppointmentDetails/hooks/useLiveUsers";

export const useOtherUsersOnTheSameAppointmentDetailsPage = () =>
  useTypedQuery({ queryKey: AppointmentDetailsKeys.otherUsersOnTheSameAppointmentDetailsPage, initialData: [] });

export const setOtherUsersOnTheSameAppointmentDetailsPage = (users: LiveUser[]) =>
  typedQueryClient.setQueryData(AppointmentDetailsKeys.otherUsersOnTheSameAppointmentDetailsPage, users);
